import { render, staticRenderFns } from "./MarkForMarketingView.vue?vue&type=template&id=132e4313&scoped=true"
import script from "./MarkForMarketingView.vue?vue&type=script&lang=js"
export * from "./MarkForMarketingView.vue?vue&type=script&lang=js"
import style0 from "./MarkForMarketingView.vue?vue&type=style&index=0&id=132e4313&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e4313",
  null
  
)

export default component.exports